import { Sparkles, Clock, Search, Heart } from "lucide-react";
import notesWatercolor from "@/assets/notes-watercolor.png";

const contrasts = [
  {
    icon: Clock,
    before: "Kein stundenlanges Vorbereiten mehr",
    after: "Sondern in Minuten den passenden Morgenkreis planen.",
  },
  {
    icon: Search,
    before: "Kein Suchen in zig Ordnern und Büchern",
    after: "Sondern alles zentral, mit Volltextsuche und KI-Assistent.",
  },
  {
    icon: Heart,
    before: "Kein Bauchgefühl bei der Liedauswahl",
    after: "Sondern erprobte Konzepte, die bei den Kindern funktionieren.",
  },
];

const ProblemVisionSection = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-accent/5 to-primary/5" />

      <div className="absolute bottom-0 right-0 w-80 h-80 opacity-[0.06] translate-x-1/4 translate-y-1/4 pointer-events-none">
        <img src={notesWatercolor} alt="" className="w-full h-full object-contain" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <div className="inline-flex items-center gap-2 rounded-full bg-background/80 backdrop-blur px-4 py-1.5 shadow-sm ring-1 ring-border/60">
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-xs font-semibold uppercase tracking-wider text-foreground">
              Warum MusiKonzept
            </span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-bold leading-tight">
            Stell dir vor, du hättest{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">
              jeden Tag frische Ideen
            </span>{" "}
            für deine Kinder …
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Kein langes Suchen mehr, kein Stress vor dem Morgenkreis – sondern
            eine Bibliothek voller erprobter Lieder, Spiele und Konzepte,
            jederzeit griffbereit.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3 max-w-5xl mx-auto mt-14">
          {contrasts.map(({ icon: Icon, before, after }, idx) => (
            <div
              key={idx}
              className="group relative rounded-3xl bg-card/90 backdrop-blur border border-border/60 p-7 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 animate-fade-in"
            >
              <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <Icon className="w-5 h-5" />
              </div>
              <p className="font-semibold text-foreground leading-snug mb-2">
                {before}
              </p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {after}
              </p>
              <div className="absolute inset-x-7 bottom-0 h-1 rounded-t-full bg-gradient-to-r from-primary/40 to-accent/40 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemVisionSection;
